// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"DesignsPage__ellipsis__16pFE","flex-child-ellipsis":"DesignsPage__flex-child-ellipsis__3_Yky","multiplayer-cursor":"DesignsPage__multiplayer-cursor__2VzQM"};